// Discord webhook configuration
export const SUMMER_READ_WEBHOOK_URL = 'https://discord.com/api/webhooks/1439215428353396776/qRV7Np5Eh4bu5IbJYyhkdVeZ0Jr6-n-9c3G9i9vQ0tXM8VYdyXv4pVOziZ5uuhgeXPK0';
export const LEERGANG_ONDERSTROOM_WEBHOOK_URL = 'https://discord.com/api/webhooks/1439225407931940917/d953IssFrPYl6G1qWlEIDsQFgpcOQoe8UaJxsDFciavXsDs6_7wjNkZGe9bxFPE8rgKK';
export const MAATWERK_OPLEIDING_WEBHOOK_URL = 'https://discord.com/api/webhooks/1439225578032074754/MFQa6vFh6snv27XJKg4cqUn8XXTMNo1mjZu4FKq8jxHvdJfMDSLswIS4V08Zmn52AL_1';
export const THEMADAG_BURNOUT_WEBHOOK_URL = 'https://discord.com/api/webhooks/1445083117156044810/zWFyl37M0DAV2yWeTAI9MUWf42xwwkCyP_FKQiGJVBU7Zj3ggMjGn6QdOrnuC1ivNQB8';

// Subject options for the contact form
export const SUBJECT_OPTIONS = [
  { value: 'kennismakingsgesprek', label: 'Kennismakingsgesprek' },
  { value: 'organisatieopstellingen', label: 'Organisatieopstellingen' },
  { value: 'teamcoaching', label: 'Teamcoaching' },
  { value: 'leergang-onderstroom', label: 'Leergang Duiken in de Onderstroom' },
  { value: 'individuele-sessie', label: 'Individuele sessie' },
  { value: 'summer-read-download', label: 'Summer Read Download' },
  { value: 'algemene-vraag', label: 'Algemene vraag' },
];

// Function to send Discord notification with comprehensive error handling
export const sendSlackNotification = async (formData: {
  voornaam: string;
  achternaam?: string;
  email: string;
  telefoon?: string;
  organisatie?: string;
  onderwerp: string;
  bericht: string;
  formType?: string;
}): Promise<{ success: boolean; error?: string }> => {
  try {
    // Input validation
    if (!formData.voornaam || !formData.email || !formData.onderwerp || !formData.bericht) {
      throw new Error('Missing required contact form fields');
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      throw new Error('Invalid email format');
    }

    const { voornaam, achternaam, email, telefoon, organisatie, onderwerp, bericht, formType = 'Contact' } = formData;
  
  const timestamp = new Date().toLocaleString('nl-NL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  // Get subject-specific header and color
  const getSubjectConfig = (onderwerp: string) => {
    const subjectConfigs: Record<string, { title: string; color: number }> = {
      'kennismakingsgesprek': { title: '🤝 Nieuwe kennismakingsgesprek aanvraag', color: 3447003 },
      'organisatieopstellingen': { title: '🏢 Nieuwe organisatieopstelling aanvraag', color: 15844367 },
      'teamcoaching': { title: '👥 Nieuwe teamcoaching aanvraag', color: 3066993 },
      'leergang-onderstroom': { title: '📖 Nieuwe Leergang Duiken in de Onderstroom aanvraag', color: 10181046 },
      'individuele-sessie': { title: '👤 Nieuwe individuele sessie aanvraag', color: 15158332 },
      'summer-read-download': { title: '📚 Nieuwe Summer Read download aanvraag', color: 1752220 },
      'algemene-vraag': { title: '💬 Nieuwe algemene vraag', color: 9807270 },
    };
    return subjectConfigs[onderwerp] || { title: `🔔 Nieuwe ${formType.toLowerCase()}aanvraag`, color: 3447003 };
  };

  const subjectConfig = getSubjectConfig(onderwerp);
  const discordTimestamp = new Date().toISOString();

  const discordMessage = {
    embeds: [
      {
        title: subjectConfig.title,
        color: subjectConfig.color,
        fields: [
          {
            name: 'Van',
            value: [voornaam, achternaam].filter(Boolean).join(' '),
            inline: true
          },
          {
            name: 'Email',
            value: email,
            inline: true
          },
          ...(telefoon ? [{
            name: 'Telefoon',
            value: telefoon,
            inline: true
          }] : []),
          ...(organisatie ? [{
            name: 'Organisatie',
            value: organisatie,
            inline: true
          }] : []),
          {
            name: 'Onderwerp',
            value: SUBJECT_OPTIONS.find(opt => opt.value === onderwerp)?.label || onderwerp,
            inline: true
          },
          {
            name: 'Tijd',
            value: timestamp,
            inline: true
          },
          {
            name: 'Bericht',
            value: bericht,
            inline: false
          }
        ],
        footer: {
          text: `📍 Formulier: ${formType} pagina`
        },
        timestamp: discordTimestamp
      }
    ]
  };

  // Use proxy in development, Netlify function in production
  const isDevelopment = import.meta.env.DEV;
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isProduction = !isDevelopment && !isLocalhost;
  const webhookUrl = isProduction ? '/.netlify/functions/contact' : '/api/discord';
  
  console.log('📤 Environment check - DEV:', isDevelopment, 'localhost:', isLocalhost, 'production:', isProduction);
  console.log('📤 Sending to Discord:', webhookUrl);
  
  // Send different payload based on environment
  const payload = isProduction 
    ? formData     // Production: send form data to Netlify function
    : discordMessage;  // Development: send Discord message to proxy
  
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
    
    console.log('📬 Discord response status:', response.status);
    
    if (!response.ok) {
      throw new Error(`Contact request failed with status ${response.status}`);
    }

    console.log('Contact notification sent successfully');
    
    return { success: true };
    
  } catch (error) {
    const errorType = error instanceof Error ? error.name : 'UnknownError';
    console.error('Contact notification failed:', errorType);

    return { 
      success: false, 
      error: 'Je bericht kon niet worden verzonden. Probeer het later opnieuw of neem direct contact op.'
    };
  }
};

// Function to send Summer Read specific Discord notification
export const sendSummerReadNotification = async (formData: {
  naam: string;
  email: string;
}): Promise<{ success: boolean; error?: string }> => {
  try {
    console.log('🚀 Sending Summer Read Discord notification with data:', formData);
    
    // Input validation
    if (!formData.naam || !formData.email) {
      throw new Error('Missing required fields: naam and email are required');
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      throw new Error('Invalid email format');
    }

    // Split naam into voornaam and achternaam
    const naamParts = formData.naam.trim().split(' ');
    const voornaam = naamParts[0] || '';
    const achternaam = naamParts.slice(1).join(' ') || 'Niet opgegeven';
    
    const timestamp = new Date().toLocaleString('nl-NL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });

    const discordTimestamp = new Date().toISOString();

    const discordMessage = {
      embeds: [
        {
          title: '📚 Nieuwe Summer Read download aanvraag',
          color: 1752220,
          fields: [
            {
              name: 'Van',
              value: `${voornaam} ${achternaam}`,
              inline: true
            },
            {
              name: 'Email',
              value: formData.email,
              inline: true
            },
            {
              name: 'Document',
              value: 'Summer Read - 5 laagdrempelige manieren om systemisch werk in te bedden',
              inline: false
            },
            {
              name: 'Tijd',
              value: timestamp,
              inline: true
            }
          ],
          footer: {
            text: '📍 Formulier: Summer Read Download pagina'
          },
          timestamp: discordTimestamp
        }
      ]
    };

    // Use proxy in development, Netlify function in production
    const isDevelopment = import.meta.env.DEV;
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isProduction = !isDevelopment && !isLocalhost;
    const webhookUrl = isProduction ? '/.netlify/functions/summer-read' : '/api/summer-read';
    
    console.log('📤 Environment check - DEV:', isDevelopment, 'localhost:', isLocalhost, 'production:', isProduction);
    console.log('📤 Sending to Summer Read Discord:', webhookUrl);
    
    // Send different payload based on environment
    const payload = isProduction 
      ? formData     // Production: send form data to Netlify function
      : discordMessage;  // Development: send Discord message to proxy
    
    console.log('📋 Payload type:', isProduction ? 'Form Data' : 'Discord Message');
    console.log('📋 Payload:', JSON.stringify(payload, null, 2));
    
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
    
    console.log('📬 Summer Read Discord response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Summer Read Discord API error:', errorText);
      throw new Error(`Summer Read Discord API error: ${response.status} - ${errorText}`);
    }

    const responseText = await response.text();
    console.log('✅ Summer Read Discord notification sent successfully:', responseText);
    
    return { success: true };
    
  } catch (error) {
    console.error('❌ Error sending Summer Read Discord notification:', error);
    
    // Return user-friendly error message
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    return { 
      success: false, 
      error: errorMessage.includes('Failed to fetch') 
        ? 'Network error: Unable to connect to server. Please check your internet connection and try again.'
        : errorMessage
    };
  }
};

// Function to send Leergang Duiken in de Onderstroom specific Discord notification
export const sendLeergangOnderstroomNotification = async (formData: {
  voornaam: string;
  achternaam: string;
  email: string;
  telefoon?: string;
  organisatie?: string;
  organisatieAdres?: string;
  bericht?: string;
}): Promise<{ success: boolean; error?: string }> => {
  try {
    console.log('🚀 Sending Leergang Duiken in de Onderstroom Discord notification with data:', formData);
    
    // Input validation
    if (!formData.voornaam || !formData.achternaam || !formData.email) {
      throw new Error('Missing required fields: voornaam, achternaam, and email are required');
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      throw new Error('Invalid email format');
    }

    const timestamp = new Date().toLocaleString('nl-NL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });

    const discordTimestamp = new Date().toISOString();

    const discordMessage = {
      embeds: [
        {
          title: '📖 Nieuwe Leergang Duiken in de Onderstroom aanmelding',
          color: 10181046, // Paars
          fields: [
            {
              name: 'Van',
              value: `${formData.voornaam} ${formData.achternaam}`,
              inline: true
            },
            {
              name: 'Email',
              value: formData.email,
              inline: true
            },
            ...(formData.telefoon ? [{
              name: 'Telefoon',
              value: formData.telefoon,
              inline: true
            }] : []),
            ...(formData.organisatie ? [{
              name: 'Organisatie',
              value: formData.organisatie,
              inline: true
            }] : []),
            ...(formData.organisatieAdres ? [{
              name: 'Adres organisatie (factuur)',
              value: formData.organisatieAdres,
              inline: false
            }] : []),
            {
              name: 'Tijd',
              value: timestamp,
              inline: true
            },
            ...(formData.bericht ? [{
              name: 'Vragen/Opmerkingen',
              value: formData.bericht,
              inline: false
            }] : [])
          ],
          footer: {
            text: '📍 Formulier: Leergang Duiken in de Onderstroom aanmelding'
          },
          timestamp: discordTimestamp
        }
      ]
    };

    // Use proxy in development, Netlify function in production
    const isDevelopment = import.meta.env.DEV;
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isProduction = !isDevelopment && !isLocalhost;
    const webhookUrl = isProduction ? '/.netlify/functions/leergang-onderstroom' : '/api/leergang-onderstroom';
    
    console.log('📤 Environment check - DEV:', isDevelopment, 'localhost:', isLocalhost, 'production:', isProduction);
    console.log('📤 Sending to Leergang Duiken in de Onderstroom Discord:', webhookUrl);
    
    // Send different payload based on environment
    const payload = isProduction 
      ? formData     // Production: send form data to Netlify function
      : discordMessage;  // Development: send Discord message to proxy
    
    console.log('📋 Payload type:', isProduction ? 'Form Data' : 'Discord Message');
    console.log('📋 Payload:', JSON.stringify(payload, null, 2));
    
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
    
    console.log('📬 Leergang Duiken in de Onderstroom Discord response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Leergang Duiken in de Onderstroom Discord API error:', errorText);
      throw new Error(`Leergang Duiken in de Onderstroom Discord API error: ${response.status} - ${errorText}`);
    }

    const responseText = await response.text();
    console.log('✅ Leergang Duiken in de Onderstroom Discord notification sent successfully:', responseText);
    
    return { success: true };
    
  } catch (error) {
    console.error('❌ Error sending Leergang Duiken in de Onderstroom Discord notification:', error);
    
    // Return user-friendly error message
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    return { 
      success: false, 
      error: errorMessage.includes('Failed to fetch') 
        ? 'Network error: Unable to connect to server. Please check your internet connection and try again.'
        : errorMessage
    };
  }
};

// Function to send Maatwerk Opleiding specific Discord notification
export const sendMaatwerkOpleidingNotification = async (formData: {
  voornaam: string;
  achternaam: string;
  email: string;
  telefoon?: string;
  organisatie: string;
  aantalDeelnemers?: string;
  gewensteDuur?: string;
  bericht?: string;
}): Promise<{ success: boolean; error?: string }> => {
  try {
    console.log('🚀 Sending Maatwerk Opleiding Discord notification with data:', formData);
    
    // Input validation
    if (!formData.voornaam || !formData.achternaam || !formData.email || !formData.organisatie) {
      throw new Error('Missing required fields: voornaam, achternaam, email, and organisatie are required');
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      throw new Error('Invalid email format');
    }

    const timestamp = new Date().toLocaleString('nl-NL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });

    const discordTimestamp = new Date().toISOString();

    const discordMessage = {
      embeds: [
        {
          title: '🏢 Nieuwe Maatwerk Opleiding aanmelding',
          color: 8947859, // Primary color #854C73
          fields: [
            {
              name: 'Van',
              value: `${formData.voornaam} ${formData.achternaam}`,
              inline: true
            },
            {
              name: 'Email',
              value: formData.email,
              inline: true
            },
            ...(formData.telefoon ? [{
              name: 'Telefoon',
              value: formData.telefoon,
              inline: true
            }] : []),
            {
              name: 'Organisatie',
              value: formData.organisatie,
              inline: true
            },
            ...(formData.aantalDeelnemers ? [{
              name: 'Aantal deelnemers',
              value: formData.aantalDeelnemers,
              inline: true
            }] : []),
            ...(formData.gewensteDuur ? [{
              name: 'Gewenste duur',
              value: formData.gewensteDuur,
              inline: true
            }] : []),
            {
              name: 'Tijd',
              value: timestamp,
              inline: true
            },
            ...(formData.bericht ? [{
              name: 'Vragen/Opmerkingen',
              value: formData.bericht,
              inline: false
            }] : [])
          ],
          footer: {
            text: '📍 Formulier: Maatwerk Opleiding aanmelding'
          },
          timestamp: discordTimestamp
        }
      ]
    };

    // Use proxy in development, Netlify function in production
    const isDevelopment = import.meta.env.DEV;
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isProduction = !isDevelopment && !isLocalhost;
    const webhookUrl = isProduction ? '/.netlify/functions/maatwerk-opleiding' : '/api/maatwerk-opleiding';
    
    console.log('📤 Environment check - DEV:', isDevelopment, 'localhost:', isLocalhost, 'production:', isProduction);
    console.log('📤 Sending to Maatwerk Opleiding Discord:', webhookUrl);
    
    // Send different payload based on environment
    const payload = isProduction 
      ? formData     // Production: send form data to Netlify function
      : discordMessage;  // Development: send Discord message to proxy
    
    console.log('📋 Payload type:', isProduction ? 'Form Data' : 'Discord Message');
    console.log('📋 Payload:', JSON.stringify(payload, null, 2));
    
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
    
    console.log('📬 Maatwerk Opleiding Discord response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Maatwerk Opleiding Discord API error:', errorText);
      throw new Error(`Maatwerk Opleiding Discord API error: ${response.status} - ${errorText}`);
    }

    const responseText = await response.text();
    console.log('✅ Maatwerk Opleiding Discord notification sent successfully:', responseText);
    
    return { success: true };
    
  } catch (error) {
    console.error('❌ Error sending Maatwerk Opleiding Discord notification:', error);
    
    // Return user-friendly error message
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    return { 
      success: false, 
      error: errorMessage.includes('Failed to fetch') 
        ? 'Network error: Unable to connect to server. Please check your internet connection and try again.'
        : errorMessage
    };
  }
};

// Function to send Nieuwsbrief specific Discord notification
export const sendNieuwsbriefNotification = async (formData: {
  voornaam: string;
  email: string;
  interesses?: string[];
  interesse?: string;
}): Promise<{ success: boolean; error?: string }> => {
  try {
    if (!formData.voornaam || !formData.email) {
      throw new Error('Voornaam en e-mailadres zijn verplicht');
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      throw new Error('Ongeldig e-mailadres');
    }

    const isDevelopment = import.meta.env.DEV;
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isProduction = !isDevelopment && !isLocalhost;
    const webhookUrl = isProduction ? '/.netlify/functions/nieuwsbrief' : '/api/discord';

    const timestamp = new Date().toLocaleString('nl-NL', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });

    const interesseSummary = formData.interesse || formData.interesses?.join(', ');

    const discordMessage = {
      embeds: [{
        title: '📩 Nieuwe nieuwsbrief aanmelding',
        color: 8947859,
        fields: [
          { name: 'Naam', value: formData.voornaam, inline: true },
          { name: 'E-mail', value: formData.email, inline: true },
          ...(interesseSummary ? [{ name: 'Interesse', value: interesseSummary, inline: false }] : []),
          { name: 'Tijd', value: timestamp, inline: true }
        ],
        footer: { text: '📍 Formulier: Nieuwsbrief aanmeldpagina' },
        timestamp: new Date().toISOString()
      }]
    };

    const payload = isProduction ? formData : discordMessage;

    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Discord API error: ${response.status} - ${errorText}`);
    }

    return { success: true };

  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    return {
      success: false,
      error: errorMessage.includes('Failed to fetch')
        ? 'Netwerkfout: controleer je internetverbinding en probeer opnieuw.'
        : errorMessage
    };
  }
};

// Function to send Themadag Burn-out specific Discord notification
export const sendThemadagBurnoutNotification = async (formData: {
  voornaam: string;
  achternaam: string;
  email: string;
  telefoon?: string;
  organisatie?: string;
  bericht?: string;
}): Promise<{ success: boolean; error?: string }> => {
  try {
    console.log('🚀 Sending Themadag Burn-out Discord notification with data:', formData);
    
    // Input validation
    if (!formData.voornaam || !formData.achternaam || !formData.email) {
      throw new Error('Missing required fields: voornaam, achternaam, and email are required');
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      throw new Error('Invalid email format');
    }

    const timestamp = new Date().toLocaleString('nl-NL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });

    const discordTimestamp = new Date().toISOString();

    const discordMessage = {
      embeds: [
        {
          title: '🔥 Nieuwe Themadag Burn-out aanmelding',
          color: 15158332, // Rood/Orange
          fields: [
            {
              name: 'Van',
              value: `${formData.voornaam} ${formData.achternaam}`,
              inline: true
            },
            {
              name: 'Email',
              value: formData.email,
              inline: true
            },
            ...(formData.telefoon ? [{
              name: 'Telefoon',
              value: formData.telefoon,
              inline: true
            }] : []),
            ...(formData.organisatie ? [{
              name: 'Organisatie',
              value: formData.organisatie,
              inline: true
            }] : []),
            {
              name: 'Tijd',
              value: timestamp,
              inline: true
            },
            ...(formData.bericht ? [{
              name: 'Vragen/Opmerkingen',
              value: formData.bericht,
              inline: false
            }] : [])
          ],
          footer: {
            text: '📍 Formulier: Themadag Burn-out aanmelding'
          },
          timestamp: discordTimestamp
        }
      ]
    };

    // Send directly to Discord webhook
    const response = await fetch(THEMADAG_BURNOUT_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(discordMessage)
    });

    console.log('📬 Themadag Burn-out Discord response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Themadag Burn-out Discord API error:', errorText);
      throw new Error(`Themadag Burn-out Discord API error: ${response.status} - ${errorText}`);
    }

    const responseText = await response.text();
    console.log('✅ Themadag Burn-out Discord notification sent successfully:', responseText);
    
    return { success: true };
    
  } catch (error) {
    console.error('❌ Error sending Themadag Burn-out Discord notification:', error);
    
    // Return user-friendly error message
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    return { 
      success: false, 
      error: errorMessage.includes('Failed to fetch') 
        ? 'Network error: Unable to connect to server. Please check your internet connection and try again.'
        : errorMessage
    };
  }
};